export class SponsorListSummary {
  totalAmount = 0;
  amountPaid = 0;
  amountUnpaid = 0;
}
